<script>
import MyReviewMixin from '@/mixins/my_review'
import MyReviewTable from '@/components/MyReviewTable'

export default {
  name: 'MyReview',
  mixins: [MyReviewMixin],
  props: {
    activeTab: { type: String, default: '' },
    formType: { type: String, default: 'my_review_new' }
  },
  data() {
    return {
      reviewTable: {
        formType: 'my_review_new'
      },
      snModalTitle: '',
      newArmStaffSubmitted: false
    }
  },
  components: {
    MyReviewTable
  },
  methods: {
    attachNewArmStaffFormListeners() {
      const formComponent =
        this.$refs.formEdit && this.$refs.formEdit.$refs.form

      if (!formComponent || formComponent.__newArmStaffResetBound) {
        this.setNewArmStaffSubmitDisabled(this.newArmStaffSubmitted)
        return
      }

      formComponent.$on('resetForm', this.resetNewArmStaffSubmitState)
      formComponent.__newArmStaffResetBound = true
      this.setNewArmStaffSubmitDisabled(this.newArmStaffSubmitted)
    },
    setNewArmStaffSubmitDisabled(disabled) {
      const formComponent =
        this.$refs.formEdit && this.$refs.formEdit.$refs.form

      if (!formComponent || !formComponent.$el) {
        return
      }

      const submitButton = Array.from(
        formComponent.$el.querySelectorAll('button.button:not([type="reset"])')
      ).find(button => button.textContent.trim() == formComponent.submitLabel)

      if (submitButton) {
        submitButton.disabled = disabled
      }
    },
    resetNewArmStaffSubmitState() {
      this.newArmStaffSubmitted = false
      this.$nextTick(() => {
        this.setNewArmStaffSubmitDisabled(false)
      })
    },
    myEmailsFormSubmit(data) {
      this.reviewTable.formType = 'my_review_subscriptions'
      this.buildRequestMessage(data, 'myEmailsFormEdit')
      if (this.requestMessage == '') {
        alert('No subscription change requested')
        return
      }
      this.snModalTitle = 'Update Email List Subscriptions Request Submitted'
      this.requestSubject = 'Update Email List Subscriptions'
      this.graphql(this.sendEmailMutation, {
        to: process.env.VUE_APP_SUPPORT_EMAIL,
        subject: this.requestSubject,
        message: this.requestMessage
      })
      this.$bvModal.show('sn-request-submitted')
    },
    newUserFormSubmit(data) {
      if (this.newArmStaffSubmitted) {
        return
      }

      this.reviewTable.formType = 'my_review_new'
      if (!data.newPersonId && !data.name) {
        alert('You must enter a new user')
        return
      }
      this.buildRequestMessage(data)
      this.snModalTitle = 'New ARM Staff Request Submitted'
      this.requestSubject = `${data.updateType} - ${
        data.username && data.username != '' ? data.username : data.name
      }`
      this.newArmStaffSubmitted = true
      this.$nextTick(() => {
        this.setNewArmStaffSubmitDisabled(true)
      })
      this.graphql(this.sendEmailMutation, {
        to: process.env.VUE_APP_STAFF_EMAIL,
        subject: this.requestSubject,
        message: this.requestMessage
      })
        .then(() => {
          this.$bvModal.show('sn-request-submitted')
        })
        .catch(() => {
          this.resetNewArmStaffSubmitState()
          alert(
            'Unable to submit New ARM Staff Request at this time. Please try again.'
          )
        })
    },
    fieldValueChanged(fieldName, newValue, extras) {
      if (fieldName == 'groupRecords') {
        if (extras.record.selected && extras.record.associatedEmails) {
          let emails = extras.record.associatedEmails.split(/, /g)
          let activeEmailRecords = this.$refs.formEdit.$refs.form.formData
            .activeEmailRecords
          for (let email of emails) {
            if (activeEmailRecords.find(record => record.emailList == email)) {
              activeEmailRecords.find(
                record => record.emailList == email
              ).selected = true
            }
          }
          //console.log(activeEmailRecords)
          this.$set(this.$refs.formEdit, 'formData', {
            ...this.$refs.formEdit.$refs.form.formData,
            activeEmailRecords
          })
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.attachNewArmStaffFormListeners()
    })
  },
  updated() {
    this.attachNewArmStaffFormListeners()
  },
  beforeDestroy() {
    const formComponent = this.$refs.formEdit && this.$refs.formEdit.$refs.form

    if (formComponent && formComponent.__newArmStaffResetBound) {
      formComponent.$off('resetForm', this.resetNewArmStaffSubmitState)
      delete formComponent.__newArmStaffResetBound
    }
  }
}
</script>

<template>
  <div class="my-review-page">
    <GraphQLFormEdit
      formType="my_review"
      :recordId="myPersonId"
      :activeTab="activeTab"
      editRecordRoute="myReview"
      editRecordTabRoute="myReviewTab"
      :key="myPersonId"
    >
      <template v-slot:JoinTable(myEmailLists)>
        <GraphQLFormEdit
          formType="my_review_subscriptions"
          :recordId="myPersonId"
          :submitTriggerInsteadOfSave="true"
          @submitForm="myEmailsFormSubmit"
          ref="myEmailsFormEdit"
        />
      </template>
      <template v-slot:JoinTable(groupOwnerActive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(emailOwnerActive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(emailOwnerInactive)="joinTable">
        <MyReviewTable formType="my_review" :reviewTable="joinTable" />
      </template>
      <template v-slot:JoinTable(newArmStaff)>
        <GraphQLFormEdit
          formType="my_review_new"
          :recordId="myPersonId"
          :submitTriggerInsteadOfSave="true"
          @submitForm="newUserFormSubmit"
          @fieldValueChanged="fieldValueChanged"
          ref="formEdit"
        />
      </template>
    </GraphQLFormEdit>
    <b-modal
      id="sn-request-submitted"
      :title="snModalTitle"
      size="xl"
      scrollable
      centered
      hide-footer
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <b-row>
        <b-col cols="2" class="font-weight-bold">Subject:</b-col>
        <b-col>{{ requestSubject }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="2" class="font-weight-bold">
          Message:
        </b-col>
        <b-col>
          <pre>{{ requestMessage }}</pre>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style>
.my-review-page .button:disabled,
.my-review-page .button[disabled] {
  background-color: #9aa7b8 !important;
  color: #eef2f7 !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.my-review-page .button:disabled:hover,
.my-review-page .button[disabled]:hover {
  cursor: not-allowed !important;
}
</style>
